import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TransitionObject} from '@PosterWhiteboard/models/transition.class';

export function useGetKeyFromTransitionOfActiveItem<T extends keyof TransitionObject>(key: T): TransitionObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'transition' in item && item.transition[key] !== undefined) {
      return item.transition[key];
    }

    return undefined;
  });
}
